import { render, staticRenderFns } from "./UserProgress.vue?vue&type=template&id=74282a5f&scoped=true&"
import script from "./UserProgress.vue?vue&type=script&lang=js&"
export * from "./UserProgress.vue?vue&type=script&lang=js&"
import style0 from "./UserProgress.vue?vue&type=style&index=0&id=74282a5f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74282a5f",
  null
  
)

export default component.exports